<div class="d-flex flex-row" style="margin-bottom: 10px">
  <div class="flex-fill w-50">
    <div class="d-flex flex-column">
      <div class="text-large inline">
          {{integration().name}} - (
            @if(this.selectedServer() && this.selectedServer()?.serverId !== "0"){
              Running on {{this.selectedServer()?.description}}
            }
            @else {
              Not Currently Running on the Server
            }
          )

      </div>
      <div class="text-medium inline"><b>Updated Date:</b> {{ integration().updatedDate | date: 'EEEE, MMMM d, y, h:mm:ss a ZZZZ'}}</div>
      <div class="text-medium inline"><b>Initial Creation Date:</b> {{ integration().initialCreationDate | date: 'EEEE, MMMM d, y, h:mm:ss a ZZZZ'}}</div>
      <br/>
      <div>
        @if(checkAccess(['LOSTalker.Admin']))
        {
          <span class="text-large inline me-2">Change Running Server</span>
          <app-server-dropdown-view
            (serverSelectEvent)="changeServer($event)"
            [serverList]="servers()"
            [overrideId]="integration().serverId"
          ></app-server-dropdown-view>
        }
      </div>

      <section>
        <app-integration-lock 
          (lockReasonSubmitted)="updateLock($event)" 
          [locked]="integration().locked" 
          [lockReason]="integration().lockReason" 
          [displayAsCheckbox]="true" 
          [disabled]="!checkAccess(['LOSTalker.Admin']) || updatingIntegration()"
          #lockReason>
        </app-integration-lock>

        <mat-checkbox
          [disabled]="!checkAccess(['LOSTalker.Admin'])"
          [(ngModel)]="integration().ipRestricted"
          [ngClass]="{'orange-label': integration().ipRestricted}"
          (change)="updateRestrictIP()">
          IP Restricted
        </mat-checkbox>

        <mat-checkbox
          [disabled]="!checkAccess(['LOSTalker.Admin'])"
          [(ngModel)]="integration().selfHosted"
          [ngClass]="{'orange-label': integration().selfHosted}"
          (change)="updateSelfHosted()">
          Self Hosted
        </mat-checkbox>
        @if(checkAccess(['LOSTalker.Admin']))
        {
          <button matButton="elevated" class="ms-2"
            (click)="openEditIntegrationDialog()"
            [disabled]="savingInformation()">
            Update Integration Name
          </button>
        }
      </section>
    </div>

  </div>
  <div class="flex-fill w-50">
    @if(showIdentifiersComments() && identifiers())
    {
      <app-lt-scroll-cards
        [items]="identifiers()"
        [trackingField]="identifierCardTrackerFn"
        [bodyTemplate]="identifierCardTemplate"
        [headerTemplate]="identifierCardHeaderTemplate"
      ></app-lt-scroll-cards>
    }
  </div>
</div>

<ng-template #editIntegrationDialog>
  <app-edit-integration [integration]="integration()" [integrations]="integrations()" #editIntegrationName>
  </app-edit-integration>
</ng-template>

<ng-template #identifierCardHeaderTemplate let-item>
  <mat-card-title class="mx-2">
    <div class="d-flex align-items-center justify-content-between">
      <span>{{item.identifierNameValue}}</span>
      <mat-chip-set>
        <mat-chip>{{item.destinationName}}</mat-chip>
      </mat-chip-set>
    </div>
  </mat-card-title>
</ng-template>

<ng-template #identifierCardTemplate let-item>
  <mat-divider class="my-1"></mat-divider>
  <div class="row">
    <div class="col-3">Integration ID</div>
    <div class="col">
      {{item.integrationId}}
      <mat-icon class="material-icons-outlined tiny-icon ms-1" [cdkCopyToClipboard]="item.integrationId" matTooltip="Copy Integration ID to Clipboard">content_copy</mat-icon>
    </div>
  </div>
  <div class="row">
    <div class="col-3">Identifier ID</div>
    <div class="col-4">{{item.identifierIdValue}}</div>
  </div>
  <mat-divider class="my-1"></mat-divider>
  <div class="row">
    <mat-chip-set>
      <mat-chip [disabled]="!item.canDataSwap">
        DataSwap: @if (item.canDataSwap) { <span>Yes</span> } @else { <span>No</span> }
      </mat-chip>
      <mat-chip [disabled]="!item.canFastFetch">
        FastFetch: @if (item.canFastFetch) { <span>Yes</span> } @else { <span>No</span> }
      </mat-chip>
      <mat-chip [disabled]="!item.isMABase">
        MABase: @if (item.isMABase) { <span>Yes</span> } @else { <span>No</span> }
      </mat-chip>
      <mat-chip [disabled]="!item.isMABaseCustom">
        MABaseCustom: @if (item.isMABaseCustom) { <span>Yes</span> } @else { <span>No</span> }
      </mat-chip>
    </mat-chip-set>
  </div>
  @if(item.comments){
    <mat-divider class="my-1"></mat-divider>
    <div class="row">
      <div class="col">Comments: {{item.comments}}</div>
    </div>
  }
</ng-template>
